import { render, staticRenderFns } from "./ContentNotAvalaible.vue?vue&type=template&id=051c6c6e&scoped=true&"
import script from "./ContentNotAvalaible.vue?vue&type=script&lang=ts&"
export * from "./ContentNotAvalaible.vue?vue&type=script&lang=ts&"
import style0 from "./ContentNotAvalaible.vue?vue&type=style&index=0&id=051c6c6e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051c6c6e",
  null
  
)

export default component.exports